/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";
import { getConfigValues, updateConfigValue } from "../../../sharedServices/configService";

const COMPONENT_NAME = "Admin services/Dashboard Service";

/**
 * Gets all of the Agent statuses
 */
export const listDashboardUrlConfigs = async () => {
	try {
		let response = await getConfigValues([
			"ENABLE_OPENSEARCH_DASHBOARDS",
			"REACT_APP_DASHBOARD_CONFIGS",
			"ADMINBACKEND_PROXY_DASHBOARD_URL",
			"OPENSEARCH_DASHBOARD_DOMAIN",
		]);
		return {
			REACT_APP_DASHBOARD_CONFIGS: response.REACT_APP_DASHBOARD_CONFIGS || [],
			ENABLE_OPENSEARCH_DASHBOARDS: response.ENABLE_OPENSEARCH_DASHBOARDS || false,
			ADMINBACKEND_PROXY_DASHBOARD_URL: response.ADMINBACKEND_PROXY_DASHBOARD_URL || "",
			OPENSEARCH_DASHBOARD_DOMAIN: response.OPENSEARCH_DASHBOARD_DOMAIN || "",
		};
	} catch (error) {
		v2.error(`Error getting dashboard configurations`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.GET_AGENT_STATUSES_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};

/**
 * Sends the list of new status alert configurations to the backend lambda
 * where they will be updated, removed, or created in the dynamo.
 * @param {Object} statusAlerts The array of status alerts.
 * @returns The updated list of status alerts
 */
export const updateDashboardUrlConfigs = async (dashboardUrls) => {
	try {
		let response = await updateConfigValue("REACT_APP_DASHBOARD_CONFIGS", dashboardUrls);
		return response.data;
	} catch (error) {
		v2.error(`Error while updating dashboard configurations`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.GET_AGENT_STATUS_ALERTS_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};
